import React, { useEffect, useState } from 'react';
import MarketingDetailPage from './MarketingDetailPage';
import { META_ADS_CONFIG } from '../constants/marketingMetaAdsColumnsConfig';

const axios = require('axios').default;

const FtuxCard = ({ title, body, ctaLabel, ctaHref }) => (
  <div className="card mx-auto my-5 p-4 text-center" style={{ maxWidth: 560 }}>
    <h3 className="font-weight-bold mb-2">{title}</h3>
    <p className="text-muted mb-4">{body}</p>
    <div>
      <a href={ctaHref} className="btn btn-primary">{ctaLabel}</a>
    </div>
  </div>
);

function ReportingMarketingMetaAdsPage({
  team, csrfToken, currentUser, venueOwnerships,
  metaAdsConnected, hasMatches, integrationDetailsPath, metaSocialAdsPath,
}) {
  const [filterOptions, setFilterOptions] = useState({});

  useEffect(() => {
    if (!team?.id || !metaAdsConnected || !hasMatches) return;
    axios.get(`/teams/${team.id}/reporting/marketing/meta-ads/filter_options.json`)
      .then((res) => setFilterOptions(res.data || {}))
      .catch((err) => { console.error('Failed to load filter options', err); });
  }, [team?.id, metaAdsConnected, hasMatches]);

  if (!metaAdsConnected) {
    return (
      <FtuxCard
        title="Track your Meta Ads performance"
        body="Connect Meta Ads to see spend, ROAS, and pacing across your events."
        ctaLabel="Connect Meta Ads"
        ctaHref={integrationDetailsPath}
      />
    );
  }

  if (!hasMatches) {
    return (
      <FtuxCard
        title="Map your ads to events"
        body="Meta Ads is connected, but no ads are matched to events yet. Match ads to start seeing per-event reporting."
        ctaLabel="Manage Meta Ads"
        ctaHref={metaSocialAdsPath}
      />
    );
  }

  return (
    <MarketingDetailPage
      team={team}
      csrfToken={csrfToken}
      venueOwnerships={venueOwnerships}
      filterOptions={filterOptions}
      config={META_ADS_CONFIG}
    />
  );
}

export default ReportingMarketingMetaAdsPage;
